import { FDTableCell } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';

const QuestionnaireTableCell = ({ value, hidden, align }) => ((hidden) ? null : (<FDTableCell align={align}>{value}</FDTableCell>));
const QuestionnaireTableCellNumber = (props) => (<QuestionnaireTableCell {...props} align={'right'} />);

QuestionnaireTableCell.defaultProps = {
  hidden: false,
  align: 'left',
};

QuestionnaireTableCell.propTypes = {
  value: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  align: PropTypes.string,
};

export { QuestionnaireTableCell, QuestionnaireTableCellNumber };
